import { getFileWithAccessDatasets, getFileWithAcr, getReferencedPolicyUrlAll, getResourceInfoWithAccessDatasets, getResourceInfoWithAcr, getSolidDatasetWithAccessDatasets, getSolidDatasetWithAcr, hasAccessibleAcr, saveAcrFor, isAcpControlled } from './acp.mjs';
import { hasLinkedAcr, removeAcrPolicyUrlAll, removeMemberAcrPolicyUrlAll, removeMemberPolicyUrlAll, removePolicyUrlAll } from './control.mjs';
import { addAcrPolicyUrl } from './policy/addAcrPolicyUrl.mjs';
import { addMemberAcrPolicyUrl } from './policy/addMemberAcrPolicyUrl.mjs';
import { addMemberPolicyUrl } from './policy/addMemberPolicyUrl.mjs';
import { addPolicyUrl } from './policy/addPolicyUrl.mjs';
import { getAcrPolicyUrlAll } from './policy/getAcrPolicyUrlAll.mjs';
import { getMemberAcrPolicyUrlAll } from './policy/getMemberAcrPolicyUrlAll.mjs';
import { getMemberPolicyUrlAll } from './policy/getMemberPolicyUrlAll.mjs';
import { getPolicyUrlAll } from './policy/getPolicyUrlAll.mjs';
import { removeAcrPolicyUrl } from './policy/removeAcrPolicyUrl.mjs';
import { removeMemberAcrPolicyUrl } from './policy/removeMemberAcrPolicyUrl.mjs';
import { removeMemberPolicyUrl } from './policy/removeMemberPolicyUrl.mjs';
import { removePolicyUrl } from './policy/removePolicyUrl.mjs';
import { setResourcePolicy } from './policy/setResourcePolicy.mjs';
import { createPolicy, getAllowModesV2, getDenyModesV2, getPolicy, getPolicyAll, removePolicy, setAllowModesV2, setDenyModesV2, setPolicy, createResourcePolicyFor, getResourceAcrPolicy, getResourceAcrPolicyAll, getResourcePolicy, getResourcePolicyAll, removeResourceAcrPolicy, removeResourcePolicy } from './policy.mjs';
import { addAgent, createMatcher, getAgentAll, getMatcher, getMatcherAll, removeAgent, removeMatcher, setAgent, setMatcher, addClient, getClientAll, hasAnyClient, removeClient, setAnyClient, setClient, removeAnyClient, hasAuthenticated, hasCreator, hasPublic, setAuthenticated, setCreator, setPublic, removeAuthenticated, removeCreator, removePublic, getAnyOfMatcherUrlAll, addAnyOfMatcherUrl, removeAnyOfMatcherUrl, setAnyOfMatcherUrl, getAllOfMatcherUrlAll, addAllOfMatcherUrl, removeAllOfMatcherUrl, setAllOfMatcherUrl, getNoneOfMatcherUrlAll, addNoneOfMatcherUrl, removeNoneOfMatcherUrl, setNoneOfMatcherUrl, createResourceMatcherFor, getResourceMatcher, getResourceMatcherAll, removeResourceMatcher, setResourceMatcher } from './matcher.mjs';
import { addMockAcrTo, mockAcrFor } from './mock.mjs';
import { getVcAccess } from './util/getVcAccess.mjs';
import { setVcAccess } from './util/setVcAccess.mjs';

//
const v4AcpFunctions = {
    getFileWithAccessDatasets,
    getFileWithAcr,
    getReferencedPolicyUrlAll,
    getResourceInfoWithAccessDatasets,
    getResourceInfoWithAcr,
    getSolidDatasetWithAccessDatasets,
    getSolidDatasetWithAcr,
    hasAccessibleAcr,
    saveAcrFor,
    isAcpControlled,
    getVcAccess,
    setVcAccess,
};
const v4ControlFunctions = {
    addAcrPolicyUrl,
    addMemberAcrPolicyUrl,
    addMemberPolicyUrl,
    addPolicyUrl,
    getAcrPolicyUrlAll,
    getMemberAcrPolicyUrlAll,
    getMemberPolicyUrlAll,
    getPolicyUrlAll,
    hasLinkedAcr,
    removeAcrPolicyUrl,
    removeAcrPolicyUrlAll,
    removeMemberAcrPolicyUrl,
    removeMemberAcrPolicyUrlAll,
    removeMemberPolicyUrl,
    removeMemberPolicyUrlAll,
    removePolicyUrl,
    removePolicyUrlAll,
};
const v4PolicyFunctions = {
    createPolicy,
    getAllowModes: getAllowModesV2,
    getDenyModes: getDenyModesV2,
    getPolicy,
    getPolicyAll,
    removePolicy,
    setAllowModes: setAllowModesV2,
    setDenyModes: setDenyModesV2,
    setPolicy,
    createResourcePolicyFor,
    getResourceAcrPolicy,
    getResourceAcrPolicyAll,
    getResourcePolicy,
    getResourcePolicyAll,
    removeResourceAcrPolicy,
    removeResourcePolicy,
    setResourcePolicy,
};
const v4MatcherFunctions = {
    addAgent,
    createMatcher,
    getAgentAll,
    getMatcher,
    getMatcherAll,
    removeAgent,
    removeMatcher,
    setAgent,
    setMatcher,
    addClient,
    getClientAll,
    hasAnyClient,
    removeClient,
    setAnyClient,
    setClient,
    removeAnyClient,
    hasAuthenticated,
    hasCreator,
    hasPublic,
    setAuthenticated,
    setCreator,
    setPublic,
    removeAuthenticated,
    removeCreator,
    removePublic,
    getAnyOfMatcherUrlAll,
    addAnyOfMatcherUrl,
    removeAnyOfMatcherUrl,
    setAnyOfMatcherUrl,
    getAllOfMatcherUrlAll,
    addAllOfMatcherUrl,
    removeAllOfMatcherUrl,
    setAllOfMatcherUrl,
    getNoneOfMatcherUrlAll,
    addNoneOfMatcherUrl,
    removeNoneOfMatcherUrl,
    setNoneOfMatcherUrl,
    createResourceMatcherFor,
    getResourceMatcher,
    getResourceMatcherAll,
    removeResourceMatcher,
    setResourceMatcher,
};
const v4MockFunctions = {
    addMockAcrTo,
    mockAcrFor,
};
/**
 * @hidden
 * @deprecated Please import "acp_ess_2" directly.
 */
const acp_v4 = {
    ...v4AcpFunctions,
    ...v4ControlFunctions,
    ...v4PolicyFunctions,
    ...v4MatcherFunctions,
    ...v4MockFunctions,
};

export { acp_v4 };
